<template>
  <!--  -->
  <div class="common_group ht-container">
    <div class="title">
      <img src="@/assets/images/dmIcon.png">
      <span>{{ $t('newApp.activityInfo.dmp') }}</span>
    </div>
    <iframe class="iframe-wrap common_group" :src="iframeUrl" />
  </div>
</template>
<script>
import { activityQueryDetails } from '../activitieList/service';
export default {
  data () {
    return {
      iframeUrl: '',
      iframeHeight: 0
    };
  },
  mounted () {
    this.getToolKitData();
    this.iframeHeight = window.innerHeight - 141;
  },
  methods: {
    getToolKitData () {
      activityQueryDetails.getTicketEncrypt().then(result => {
        if (result.status === '200') {
          const ticket = window.encodeURIComponent(result.data);
          activityQueryDetails.getToolKitData('RJM2602130008').then(res => {
            if (res.status === '200') {
              if (res.data) {
                const { activityCodeEncrypt } = res.data;
                const campaignNumber = window.encodeURIComponent(activityCodeEncrypt); // 'zLYmSDzIDh6ghxFvFSDgjg=='
                this.iframeUrl = `${window._env_.VUE_APP_HT_URL}/rjevent/rjEventConfig?campaignNumber=${campaignNumber}&data=${ticket}`;
              }
            }
          });
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.common_group{
  margin-bottom: 0px;
}
.ht-container{
  height: 100%;
}
.iframe-wrap{
  height: 450px;
}
</style>
